<!--相似视频-->
<template>
  <div class="related">
    <div class="header">
      <h2>{{title}}</h2>
      <span class="more" @click="clickMore">更多 ></span>
    </div>
    <ul class="list">
      <li :class="['item', type !== 'video'?{active: currentVid === li.videoVid}:null]" v-for="li in list" @click="onClick(type === 'video'?li.id:li.videoVid)" :key="li.id">
          <img :src="li.crossImg" class="img" alt="">
          <p class="text">
            {{type === 'video'?li.name:li.title}}
          </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
    currentVid: Number,
    onChange: Function,
    type: String
  },
  methods: {
    onClick: function (id) {
      this.onChange(id, this.type)
    },
    clickMore: function () {
      this.$emit('more')
    }
  }
}
</script>

<style scoped lang="less">
  .related {

  }
  .list {
    list-style: none;
    padding: 0;
    max-height: 500px;
    overflow: auto;
    margin: 0;
    .item {
      margin-bottom: 10px;
      cursor: pointer;
      font-size: 0;
      overflow: hidden;
      white-space: initial;
    }
  }
  .header {
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .header .more {
    float: right;
    font-size: 14px;
    color: #5D5E5F;
    text-decoration: none;
    cursor: pointer;
  }
  .header h2 {
    float: left;
    margin: 0;
    font-size: 15px;
  }
  .img {
    display: inline-block;
    width: 172px;
    height: 96px;
    margin-right: 20px;
  }
  .text {
    display: inline-block;
    width: 160px;
    margin: 0;
    vertical-align: top;
    color: #1E1E1E;
    font-size: 15px;
    font-weight: bolder;
  }
  .active {
    position: relative;
    &::before {
      content: "播放中";
      width: 65px;
      height: 18px;
      border-radius: 0px 3px 3px 0px;
      opacity: 0.8;
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 18px;
      position: absolute;
      left: 0;
      bottom: 10px;
      text-indent: 18px;
      background: #FF4D54 url("./images/playing.gif")no-repeat 5px 3px;
      background-size: 13px 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/related.vue